import { render, staticRenderFns } from "./AccountPhone.vue?vue&type=template&id=9b618f2c&scoped=true&"
import script from "./AccountPhone.vue?vue&type=script&lang=js&"
export * from "./AccountPhone.vue?vue&type=script&lang=js&"
import style0 from "./AccountPhone.vue?vue&type=style&index=0&id=9b618f2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b618f2c",
  null
  
)

export default component.exports